var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { lottieAnimations } from '@backrs_ui/common-ui/src/assets/lottieAnimations';
import { AppIcon } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';
import { BaseFileUpload } from '@backrs_ui/common-ui/src/molecules/FileUpload/BaseFileUpload';
import { Box, Typography } from '@mui/material';
import { keyframes } from '@mui/system';
import Lottie from 'lottie-react';
var fileUpload = appStrings.modules.profile.editProfile.fileUpload;
export var DocumentFileUpload = function (_a) {
    var onFileSelect = _a.onFileSelect, onError = _a.onError, acceptedFileTypes = _a.acceptedFileTypes, _b = _a.maxFileSize, maxFileSize = _b === void 0 ? 10 * 1024 * 1024 : _b, _c = _a.inputId, inputId = _c === void 0 ? 'file-upload' : _c, _d = _a.additionalText, additionalText = _d === void 0 ? '' : _d, _e = _a.multiple, multiple = _e === void 0 ? false : _e, _f = _a.borderVariant, borderVariant = _f === void 0 ? 'solid' : _f, children = _a.children;
    var handleFileSelect = function (files) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, onFileSelect(files)];
                case 1:
                    _a.sent();
                    return [3, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error('Error processing files:', error_1);
                    onError === null || onError === void 0 ? void 0 : onError(error_1);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    return (_jsx(BaseFileUpload, { onFileSelect: handleFileSelect, onError: onError, acceptedFileTypes: acceptedFileTypes, maxFileSize: maxFileSize, className: "document-file-upload", containerSx: dragAndDropSx(borderVariant), inputId: inputId, multiple: multiple, children: function (_a) {
            var isLoading = _a.isLoading;
            return !children ? (_jsx(Box, { sx: dragAndDropStyle, children: _jsxs(Box, { sx: uploadViewContainerSx, children: [isLoading ? (_jsx(Box, { sx: loadingContainerSx, children: _jsx(Lottie, { animationData: lottieAnimations.dotsDotting, loop: true }) })) : (_jsx(Box, { sx: iconContainerSx, children: _jsx(AppIcon, { iconName: "UploadCloud02", diameter: "20px", color: 'Gray/700' }) })), _jsxs(Typography, { children: [_jsx(Typography, { component: "span", variant: "text-sm-semibold", color: function (theme) { return theme.backrs.colors['Brand/700']; }, children: fileUpload.clickToUpload }), ' ', _jsx(Typography, { component: "span", variant: "text-sm-regular", color: function (theme) { return theme.backrs.colors['Gray/600']; }, children: fileUpload.dragAndDrop }), _jsx(Typography, { variant: "text-xs-regular", color: function (theme) { return theme.backrs.colors['Gray/600']; }, children: fileUpload.acceptedFileTypes(acceptedFileTypes, additionalText || fileUpload.maxFileSize(maxFileSize)) })] })] }) })) : (children);
        } }));
};
var commonIconSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: backrs.spacing['spacing-5xl'],
        height: backrs.spacing['spacing-5xl'],
        background: backrs.colors['Colors/Base/White'],
        boxShadow: backrs.shadows['shadow-xs-skeuomorphic'],
        border: backrs.colors['Gray/200'],
        borderRadius: backrs.radius['radius-md'],
    });
};
var loadingContainerSx = function (theme) { return (__assign({ flexDirection: 'column' }, commonIconSx(theme))); };
var iconContainerSx = function (theme) { return (__assign({ padding: "calc(".concat(theme.backrs.spacing['spacing-lg'], " - ").concat(theme.backrs.spacing['spacing-xxs'], ")") }, commonIconSx(theme))); };
var uploadViewContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        gap: backrs.spacing['spacing-lg'],
        pointerEvents: 'none',
        textAlign: 'center',
    });
};
var dragAndDropSx = function (borderVariant) {
    return function (_a) {
        var backrs = _a.backrs;
        return ({
            cursor: 'pointer',
            '&.dragover': {
                backgroundColor: backrs.colors['Gray/50'],
                border: "1px solid ".concat(backrs.colors['Brand/500']),
            },
            borderRadius: backrs.radius['radius-xl'],
            transition: 'all 0.3s ease-in-out',
            border: borderVariant === 'dashed'
                ? "1px dashed ".concat(backrs.colors['Gray/300'])
                : "1px solid ".concat(backrs.colors['Gray/200']),
            width: '100%',
        });
    };
};
var dragAndDropStyle = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        padding: "".concat(backrs.spacing['spacing-xl'], " ").concat(backrs.spacing['spacing-3xl']),
        flexDirection: 'column',
        alignItems: 'center',
        gap: backrs.spacing['spacing-xs'],
        borderRadius: backrs.radius['radius-xl'],
        background: backrs.colors['Colors/Base/White'],
        position: 'relative',
        width: '100%',
        animation: "".concat(keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    from {\n      opacity: 0;\n      transform: translateY(10px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  "], ["\n    from {\n      opacity: 0;\n      transform: translateY(10px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  "]))), " 0.3s ease-out"),
    });
};
var templateObject_1;
